import React from "react";

const InfrastructurePartners = () => {
  const partners = [
    {
      name: "Bytes",
      image: require("../../assets/images/brand/Bytes-logo.png"),
    },
    {
      name: "Career Foresight",
      image: require("../../assets/images/brand/Career-Foresight-logo.png"),
    },
    {
      name: "Netcom",
      image: require("../../assets/images/brand/netcom-logo.png"),
    },
    {
      name: "Orlando Academy",
      image: require("../../assets/images/brand/Orlando-Academy-logo.png"),
    },
    {
      name: "Netparam",
      image: require("../../assets/images/brand/netparam-logo.png"),
    },
    {
      name: "Smart Age Computers",
      image: require("../../assets/images/brand/SMART-AGE-COMPUTERS-logo.png"),
    },
  ];

  return (
    <div>
      {/* Enhanced Background decorative elements */}
      <div
        style={{
          position: "absolute",
          top: "10%",
          left: "-15%",
          width: "600px",
          height: "600px",
          background:
            "radial-gradient(circle, rgba(255, 0, 50, 0.08) 0%, rgba(255, 0, 50, 0.03) 40%, transparent 70%)",
          borderRadius: "50%",
          filter: "blur(80px)",
          animation: "float 20s ease-in-out infinite",
        }}
      ></div>

      <div
        style={{
          position: "absolute",
          bottom: "5%",
          right: "-15%",
          width: "700px",
          height: "700px",
          background:
            "radial-gradient(circle, rgba(255, 255, 255, 0.04) 0%, rgba(255, 0, 0, 0.02) 50%, transparent 70%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          animation: "float 25s ease-in-out infinite reverse",
        }}
      ></div>

      {/* Additional floating elements */}
      <div
        style={{
          position: "absolute",
          top: "60%",
          left: "10%",
          width: "200px",
          height: "200px",
          background:
            "radial-gradient(circle, rgba(255, 0, 0, 0.05) 0%, transparent 60%)",
          borderRadius: "50%",
          filter: "blur(40px)",
          animation: "pulse 15s ease-in-out infinite",
        }}
      ></div>

      <div
        className="container"
        style={{
          position: "relative",
          zIndex: 2,
          background: "rgba(255, 255, 255, 0.98)",
          borderRadius: "32px",
          padding: "80px 60px",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255, 0, 0, 0.1)",
          // boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        {/* Header Section */}
        <div style={{ marginBottom: "80px", textAlign: "center" }}>
          <div
            style={{
              display: "inline-block",
              padding: "8px 24px",
              background:
                "linear-gradient(90deg, rgba(255, 0, 0, 0.1) 0%, rgba(255, 0, 0, 0.05) 100%)",
              border: "1px solid rgba(255, 0, 0, 0.2)",
              borderRadius: "50px",
              marginBottom: "30px",
            }}
          >
            <span
              style={{
                color: "#ff4444",
                fontSize: "2rem",
                fontWeight: "500",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                fontFamily: '"Inter", "Segoe UI", sans-serif',
              }}
            >
              Trusted Partners
            </span>
          </div>

          <h2
            className="text-danger title split-collab"
            style={{ fontSize: "4rem" }}
          >
            Infrastructure & Capital
            <br /> Project Partners
          </h2>
        </div>

        {/* Partners Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "24px",
            alignItems: "center",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {partners.map((partner, index) => (
            <div key={index}
               data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"            
            >
              <div
                style={{
                  height: "140px",
                  background: "#ffffff",
                  border: "2px solid rgba(255, 0, 0, 0.1)",
                  borderRadius: "20px",
                  //backgroundImage: partner.image,
                  backgroundImage: `url(${partner.image})`,
                  transition: "all 0.5s cubic-bezier(0.23, 1, 0.320, 1)",
                  // cursor: 'pointer',
                  position: "relative",
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "20px",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform =
                    "translateY(-5px) scale(1.03)";
                  e.currentTarget.style.borderColor = "rgba(255, 0, 0, 0.4)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 20px rgba(0, 0, 0, 0.12)";
                  e.currentTarget.style.backgroundColor = "#ffffff"; // keeps image, adds white overlay
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.borderColor = "rgba(255, 0, 0, 0.1)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 15px rgba(0, 0, 0, 0.08)";
                  e.currentTarget.style.backgroundColor = "transparent"; // removes overlay, keeps image
                }}
              >
                {/* Corner accent */}
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    right: "0",
                    width: "60px",
                    height: "60px",
                    background:
                      "linear-gradient(135deg, rgba(255, 0, 0, 0.08) 0%, transparent 100%)",
                    borderRadius: "0 20px 0 60px",
                  }}
                ></div>

                {/* Enhanced hover shine effect */}
                <div
                  style={{
                    position: "absolute",
                    top: "-50%",
                    left: "-50%",
                    width: "200%",
                    height: "200%",
                    background:
                      "linear-gradient(45deg, transparent 30%, rgba(255, 0, 0, 0.1) 45%, rgba(255, 255, 255, 0.1) 55%, transparent 70%)",
                    transform: "rotate(45deg) translateX(-150%)",
                    transition: "all 0.8s cubic-bezier(0.23, 1, 0.320, 1)",
                    pointerEvents: "none",
                    opacity: "0",
                  }}
                  className="shine-effect"
                ></div>

                {/* Bottom accent line */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "60%",
                    height: "2px",
                    background:
                      "linear-gradient(90deg, transparent 0%, rgba(255, 0, 0, 0.5) 50%, transparent 100%)",
                    borderRadius: "1px",
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>

        {/* Enhanced bottom section */}
        <div style={{ marginTop: "100px", textAlign: "center" }}>
          <div
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              padding: "40px",
              background:
                "linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 0, 0, 0.02) 100%)",
              backdropFilter: "blur(20px)",
              borderRadius: "24px",
              border: "1px solid rgba(255, 255, 255, 0.08)",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-1px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "200px",
                height: "2px",
                background:
                  "linear-gradient(90deg, transparent 0%, rgba(255, 0, 0, 0.6) 50%, transparent 100%)",
                borderRadius: "1px",
              }}
            ></div>

            <p
              style={{
                fontSize: "2rem",
                fontFamily: '"Inter", "Segoe UI", sans-serif',
                lineHeight: "1.7",
                margin: "0",
                fontWeight: "300",
              }}
              className="text-danger"
            >
              Trusted by leading organizations worldwide for infrastructure and
              capital project excellence
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfrastructurePartners;
